import { $mx_hasValue } from './util'

export default {
	methods: {
		/**
		 * Necessário: oldForm e form
		 * Faz uma copia do estado do form em uma
		 * variavel chamada oldForm.
		 */
		$mx_copyOldForm() {
			this.oldForm = JSON.parse(JSON.stringify(this.form))
		},
	},

	computed: {
		/**
		 * Necessário: oldForm e form
		 * Retorna um booleano caso a variavel this.form
		 * seja diferente de oldForm.
		 */
		$mx_isFormChanged() {
			return JSON.stringify(this.form) != JSON.stringify(this.oldForm)
		},

		$mx_allFilled() {
			let allSelected = true
			for (let select in this.form) {
				if ($mx_hasValue(this.form[select])) allSelected = false
			}
			return allSelected
		},
	},
}
